import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import marginAccountProductStateSubscriptionService from '../../services/subscriptions/marginAccountProductStateSubscriptionService';
export var REQUEST_MARGIN_PRODUCTS = 'REQUEST_MARGIN_PRODUCTS';
export var RECEIVE_MARGIN_PRODUCTS = 'RECEIVE_MARGIN_PRODUCTS';
export var RECEIVE_MARGIN_PRODUCT_EVENT = 'RECEIVE_MARGIN_PRODUCT_EVENT';
export var getMarginProducts = function getMarginProducts(AccountId, OMSId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var responseObj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch(requestingMarginProducts);
              _context.next = 4;
              return dispatch(callAPI('GetMarginAccountPositions', {
                OMSId: OMSId,
                AccountId: AccountId
              }));
            case 4:
              responseObj = _context.sent;
              if (responseObj && responseObj.result === false) {
                console.error('getMarginProducts error: ', responseObj.errormsg);
              } else {
                dispatch(receiveMarginProducts(responseObj));
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);
              console.error('getMarginProducts error: ', _context.t0);
            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var subscribeToMarginAccountProducts = function subscribeToMarginAccountProducts(AccountId, OMSId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              marginAccountProductStateSubscriptionService.subscribe(function (update) {
                dispatch(receiveMarginProductEvent(update));
              });
            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var receiveMarginProductEvent = function receiveMarginProductEvent(payload) {
  return {
    type: RECEIVE_MARGIN_PRODUCT_EVENT,
    payload: payload
  };
};
export var requestingMarginProducts = {
  type: REQUEST_MARGIN_PRODUCTS
};
export var receiveMarginProducts = function receiveMarginProducts(payload) {
  return {
    type: RECEIVE_MARGIN_PRODUCTS,
    payload: payload
  };
};